import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import type { MessageSeverity } from '../message/hh-message';

/**
 * A transient notification floating over the top of the viewport.
 *
 * Presentational only: the consumer decides when one shows and when it
 * goes, so there is no queue or timer here. Tapping it emits
 * `dismissed` — on a phone the whole panel is the close target, which
 * beats a tiny ✕ in the corner.
 *
 * Shares hh-message's severity vocabulary and role rule: `alert` for
 * errors, `status` for everything else.
 */
@Component({
  selector: 'hh-toast',
  standalone: true,
  template: `
    <div [class]="classes()" [attr.role]="role()" (click)="dismissed.emit()">
      <ng-content />
    </div>
  `,
  styleUrl: './hh-toast.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HhToastComponent {
  readonly severity = input<MessageSeverity>('info');
  readonly dismissed = output<void>();

  protected readonly classes = computed(() => `hh-toast hh-toast--${this.severity()}`);

  protected readonly role = computed(() => (this.severity() === 'error' ? 'alert' : 'status'));
}
